// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM10.0039 3V5.00393H8.00391V7.00002H10.0039V9.00393H8.00391V11H10.0039V13.0039H8.00391V15.0039H6V13H8V11.0039H6V9.00002H8V7.00393H6V5.00002H8V3.00002L10.0039 3Z"}}]};

const FileZipFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-zip-filled',
    ref,
    icon: element,
  },
));

FileZipFilledIcon.displayName = 'FileZipFilledIcon';

export default FileZipFilledIcon;
